import { render, staticRenderFns } from "./ModerateCampaign.vue?vue&type=template&id=5b77c073&scoped=true&"
import script from "./ModerateCampaign.vue?vue&type=script&lang=js&"
export * from "./ModerateCampaign.vue?vue&type=script&lang=js&"
import style0 from "./ModerateCampaign.vue?vue&type=style&index=0&id=5b77c073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77c073",
  null
  
)

export default component.exports